import React from 'react';
import '../../css/Rating.css';
import { Stars } from './Stars';

export const Rating = ({ score, reviews, url, platform }) => {
    return (
        <div className="rating-container">
            <a href={url ? url : "#"} target="_blank">
                <div className="rating-score-wrapper">
                    <span className="rating-score">{score}</span>
                    <Stars score={score}/>
                    <span className="rating-review-count">({reviews}) {platform}</span>
                </div>
            </a>
        </div>
    );
};
